import { useQuery } from '@tanstack/react-query';
import {
  fetchAllFieldDetails,
  fetchAllMetricData,
  fetchAllProducers,
  fetchBankDocEnum,
  fetchFieldById,
  fetchBankFarmers,
  fetchSurveyList,
  fetchSurveyDeatils,
  fetchSurveyFieldDeatils
} from './fetchers';
import { queryKeys } from '../keys';

//  Hook for field details list
export const useFieldDetails = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.allFieldDetails, params],
    queryFn: () => fetchAllFieldDetails(params)
  });

//  Hook for metrics
export const useMetricData = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.allMetricData, JSON.stringify(params)],
    queryFn: () => fetchAllMetricData(params)
  });

//  Hook for field by ID
export const useFieldById = (params) =>
  useQuery({
    queryKey: [...queryKeys.fieldById, JSON.stringify(params)],
    queryFn: () => fetchFieldById(params),
    enabled: Boolean(params?.id),
    staleTime: 0
  });

export const useAllProducers = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.allProducers, JSON.stringify(params)],
    queryFn: () => fetchAllProducers(params),
    staleTime: 0
  });

export const useBankTypes = (params = {}) =>
  useQuery({
    queryKey: [...queryKeys.bankTypeEnum, JSON.stringify(params)],
    queryFn: () => fetchBankDocEnum(params),
    staleTime: 0
  });

export const useBankFarmers = (params = {}) =>
  useQuery({
    queryKey: ['bankFarmers', JSON.stringify(params)],
    queryFn: () => fetchBankFarmers(params),
    staleTime: 0
  });

export const useSurveyList = (params) =>
  useQuery({
    queryKey: [...queryKeys.surveyList, JSON.stringify(params)],
    queryFn: () => fetchSurveyList(params),
    retry: 0
  });

export const useSurveyDetails = (surveyId, params) =>
  useQuery({
    queryKey: [...queryKeys.surveyDetails, JSON.stringify(params)],
    queryFn: () => fetchSurveyDeatils(surveyId, params),
    retry: 0,
    enabled: !!surveyId
  });

export const useSurveyFieldDetails = (fieldId, surveyId) =>
  useQuery({
    queryKey: [...queryKeys.surveyFieldDetails, fieldId, surveyId],
    queryFn: () => fetchSurveyFieldDeatils(fieldId, surveyId),
    retry: 0,
    enabled: !!fieldId
  });
